// Lightweight analytics wrapper — PostHog when configured, no-op otherwise.
// Add REACT_APP_POSTHOG_KEY (and optionally REACT_APP_POSTHOG_HOST) to
// /app/frontend/.env to enable. Without a key this module is a silent no-op,
// so it ships safely even before instrumentation goes live.

import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";

let initialized = false;

export const initAnalytics = () => {
  if (initialized || !KEY) return;
  try {
    posthog.init(KEY, {
      api_host: HOST,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      persistence: "localStorage+cookie",
      disable_session_recording: false,
    });
    initialized = true;
  } catch (e) {
    // never block the app if analytics fails
    console.warn("PostHog init failed:", e);
  }
};

export const track = (event, props = {}) => {
  if (!initialized) return;
  try {
    posthog.capture(event, props);
  } catch (e) {
    /* swallow */
  }
};

export const identify = (distinctId, props = {}) => {
  if (!initialized) return;
  try {
    posthog.identify(distinctId, props);
  } catch (e) {
    /* swallow */
  }
};

// Canonical event names (keep these stable across the codebase)
export const Events = {
  ColorSelected: "color_selected",
  ARLaunched: "ar_launched",
  ARNativeOpened: "ar_native_opened",
  ARSimulatedOpened: "ar_simulated_opened",
  ShareClicked: "share_clicked",
  ShareCompleted: "share_completed",
  CheckoutOpened: "checkout_opened",
  CheckoutSubmitted: "checkout_submitted",
  CheckoutPaid: "checkout_paid",
  ReservationsLookup: "reservations_lookup",
};
